// Vordefinierte Einsatz-Kategorien, gemeinsam genutzt von Edit- und
// Listen-Ansicht des Einsatzprotokolls.
//
// Der "key" ist bewusst der letzte Abschnitt des jeweiligen
// Übersetzungs-Keys (bzw. bei RiskboxComponent.typeCfg orientiert) – genau
// der wird als ausgewählte Kategorie im content-JSON gespeichert (siehe
// OpCategory).

export interface PredefinedCategory {
  key: string;
  translationKey: string;
  // 'all' = saisonunabhängig, wird in der Auswahlliste immer ganz oben
  // angezeigt (unabhängig von der aktuellen Sommer-/Winter-Sortierung).
  season: 'summer' | 'winter' | 'all';
}

export const PREDEFINED_CATEGORIES: PredefinedCategory[] = [
  {
    key: 'TESTDRIVE',
    translationKey: 'PRODUCT.OPREPORT.EDIT.CATEGORY.TESTDRIVE', // Kontrollfahrt
    season: 'all',
  },
  {
    key: 'STORM',
    translationKey: 'PRODUCT.EGP-SUMMER.RISKBOX.STORM', // Sturm
    season: 'summer',
  },
  {
    key: 'THUNDERSTORM',
    translationKey: 'PRODUCT.EGP-SUMMER.RISKBOX.THUNDERSTORM', // Gewitter
    season: 'summer',
  },
  {
    key: 'DRAIN',
    translationKey: 'PRODUCT.EGP-SUMMER.RISKBOX.DRAIN', // Dauerregen
    season: 'summer',
  },
  {
    key: 'HEAT',
    translationKey: 'PRODUCT.EGP-SUMMER.RISKBOX.HEAT', // Hitze
    season: 'summer',
  },
  {
    key: 'rime',
    translationKey: 'PRODUCT.EGP.RISKBOX.rime', // Reif
    season: 'winter',
  },
  {
    key: 'snow',
    translationKey: 'PRODUCT.EGP.RISKBOX.snow', // Schnee
    season: 'winter',
  },
  {
    key: 'freezingWet',
    translationKey: 'PRODUCT.EGP.RISKBOX.freezingWet', // Gefr. Nässe
    season: 'winter',
  },
  {
    key: 'freezingRain',
    translationKey: 'PRODUCT.EGP.RISKBOX.freezingRain', // Eisregen
    season: 'winter',
  },
];

// Löst eine gespeicherte Kategorie (key) auf den anzuzeigenden Text auf:
// vordefiniert -> Übersetzungs-Key (via | translate im Template), eigene
// (Freitext-)Kategorie -> der gespeicherte Text direkt (ngx-translate gibt
// einen Text ohne passenden Key unverändert zurück).
export function categoryLabel(key: string): string {
  const predefined = PREDEFINED_CATEGORIES.find(p => p.key === key);
  return predefined ? predefined.translationKey : key;
}

export interface CategoryColorSet {
  background: string;
  color: string;
  border: string;
}

// Liefert das Farbset (Hintergrund/Text/Rand) für eine gespeicherte
// Kategorie. Gemeinsam genutzt von Edit- und Listen-Ansicht, damit eine
// Kategorie überall gleich aussieht.
//
// Auf Feedback hin bewusst neutralisiert: alle Kategorien (vordefiniert wie
// eigene Freitext-Kategorien) bekommen dieselbe dezente graue Chip-Farbe
// statt individueller Farben – "wird am Ende sonst sehr bunt". Dieselben
// App-weiten Glass-Variablen wie z.B. .btn-operation-cancel /
// .category-chip--add, damit es in beiden Themes automatisch gut lesbar
// bleibt. Endgültige Entscheidung (kein Rollback-Pfad mehr) – die vorherige
// individuelle Farblogik (Riskbox-Farben je vordefinierter Kategorie,
// Palette für eigene Kategorien inkl. OpCategory.colorIndex) wurde deshalb
// komplett entfernt statt nur stillgelegt.
export function categoryColorSet(_category: { key: string }): CategoryColorSet {
  return {
    background: 'var(--glass-bg-strong)',
    color: 'var(--text-color-muted)',
    border: 'var(--glass-border)',
  };
}
